import React from 'react';

const SubjectScore = (props) => {
    const resultDetail = props.resultDetail !== undefined && props.resultDetail;
    const subject = resultDetail.subject !==undefined && resultDetail.subject;
    const subjectWiseData = resultDetail.subject_wise_data !==undefined && resultDetail.subject_wise_data


    let subjectItem = []
    let obtain_marks=0;
    let max_marks=0;
    let highestmarks=0;
    let percentage=0;
    let avgmarks=0;
    let percentile=0;
    let bio = []
    let chem = []
    let ma = []


    // let Biology = {
    //     fieldvalue: '',
    //     max_marks:0,
    //     obtain_marks: 0,
    //     highestmarks: 0,
    //  percentage: 0,
    //  avgmarks: 0,
    //  percentile: 0
    // };

    // let Chemistry = {
    //     fieldvalue: '',
    //     obtain_marks: 0,
    //     max_marks:0,
    //     highestmarks: 0,
    //  percentage: 0,
    //  avgmarks: 0,
    //  percentile: 0
    // };
    // let Mental_Ability = {
    //     fieldvalue: '',
    //     obtain_marks: 0,
    //     max_marks:0,
    //     highestmarks: 0,
    //  percentage: 0,
    //  avgmarks: 0,
    //  percentile: 0
    // };


  
    for (let sub in  subject) {
        subjectItem[sub]=subject[sub];
        // if(subject[sub].fieldvalue.toUpperCase() === 'ZOOLOGY' || subject[sub].fieldvalue.toUpperCase() === 'BOTANY' || subject[sub].fieldvalue.toUpperCase() === 'BIOLOGY'){
        //     console.log('subject[sub].percentage...',subject[sub])
        //     Biology.fieldvalue = "BIOLOGY"   
        //     Biology.obtain_marks += subject[sub].obtain_marks;
        //     Biology.max_marks += subject[sub].max_marks;
        //     Biology.highestmarks = subject[sub].bio_highestmarks;
        //     Biology.percentage = subject[sub].percentage;
        //     Biology.avgmarks = subject[sub].bio_avgmarks;
        //     Biology.percentile = subject[sub].bio_percentile; 
        // }
        
        
        // if(subject[sub].fieldvalue.toUpperCase() === 'IOC' || subject[sub].fieldvalue.toUpperCase() === 'PC' || subject[sub].fieldvalue.toUpperCase() === 'CHEMISTRY'){

        //     Chemistry.fieldvalue = "CHEMISTRY"   
        //     Chemistry.obtain_marks += subject[sub].obtain_marks;
        //     Chemistry.max_marks += subject[sub].max_marks;
        //     Chemistry.highestmarks = subject[sub].chem_highestmarks;
        //     Chemistry.percentage += subject[sub].percentage;
        //     Chemistry.avgmarks = subject[sub].chem_avgmarks;
        //     Chemistry.percentile = subject[sub].chem_percentile; 
        // } 

       
        
        // if(subject[sub].fieldvalue.toUpperCase() === 'MENTAL ABILITY' ||  subject[sub].fieldvalue.toUpperCase() === 'IQ'){
            
        //     Mental_Ability.fieldvalue = "MENTAL ABILITY"   
        //     Mental_Ability.obtain_marks += subject[sub].obtain_marks;
        //     Mental_Ability.max_marks += subject[sub].max_marks;
        //     Mental_Ability.highestmarks = subject[sub].ma_highestmarks;
        //     Mental_Ability.percentage += subject[sub].percentage;
        //     Mental_Ability.avgmarks = subject[sub].ma_avgmarks;
        //     Mental_Ability.percentile = subject[sub].ma_percentile; 
        // }  
    }

    // bio.push(Biology);
    // chem.push(Chemistry);
    // ma.push(Mental_Ability);
    // subjectItem.push(Biology)
    // subjectItem.push(Chemistry)
    // subjectItem.push(Mental_Ability)




    return (
        <>
        <div className='card bg-light p-3 mb-4'>
            {props.showTitle ? 
            <>
            <h5 className='text_primary'>Subject Score & Percentage </h5>
            <p>Track how your rating compares to your industry average.</p>
            </>
            :''
        }
            
            <div className='subject_ListWrapper'>
                <div className='sub_item_headerTitle'>
                    <div className='sub_item_titleName'>Subject</div>
                    <div className='sub_item_titleName'>Max Mark</div>
                    <div className='sub_item_titleName'>Marks</div>
                    <div className='sub_item_titleName'>Percentage</div>
                    <div className='sub_item_titleName'>Percentile</div>
                </div>
                {/* {
                    if(item.fieldvalue == "Botany" || item.fieldvalue == "Zoology" || item.fieldvalue == "Biology"){
                        bio !== undefined && bio.map((item,key) => (
                    
                            <div className='sub_itemContain  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                                <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
       
                                <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                                <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                                <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                                <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                            </div>
                        )) 
                    }
                } */}
                
                {subjectItem !== undefined && subjectItem.map((item,index) => {

                    //  if(item.fieldvalue == "IQ" || item.fieldvalue == "MENTAL ABILITY" ){
                    //     return (
                    //         <div className='sub_itemContain d-none  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                    //     <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                    //     {/* .substring(0, 2) */}
                    //     <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                    //     <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                    //     <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                    //     <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                    // </div>

                    //     )
                    // }

                    // if(item.fieldvalue == "IOC" || item.fieldvalue == "PC" || item.fieldvalue == "CHEMISTRY" ){
                    //     return (
                    //         <div className='sub_itemContain d-none  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                    //     <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                    //     {/* .substring(0, 2) */}
                    //     <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                    //     <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                    //     <div className='sub__item'><h4>{parseFloat(item.percentage).toFixed(2)}%</h4><span>Average {item.avgmarks}%</span></div>
                    //     <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                    // </div>

                    //     )
                    // }
                    // if(item.fieldvalue == "Botany" || item.fieldvalue == "ZOOLOGY" || item.fieldvalue == "BOTANY" || item.fieldvalue == "Zoology" || item.fieldvalue == "BIOLOGY" || item.fieldvalue == "Biology"){
                    //     return (
                    //         <div className='sub_itemContain d-none  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                    //     <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                    //     {/* .substring(0, 2) */}
                    //     <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                    //     <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                    //     <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                    //     <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                    // </div>

                    //     )
                    // }
                        return(
                        <div className='sub_itemContain  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                        <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                        <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                        <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                        <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                        <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                        </div>
                        )
               
                })}

                {/* {
                  chem.map((item,index) => {
                        return (
                            <div className='sub_itemContain  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                                        <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                                     
                                        <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                                        <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {parseFloat(item.highestmarks).toFixed(2)}%</span></div>
                                        <div className='sub__item'><h4>{parseFloat(item.percentage).toFixed(2)}%</h4><span>Average {item.avgmarks}%</span></div>
                                        <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                                        </div>
                        )
                    })
                } */}

                {/* {
                bio[0].fieldvalue!=='' && bio.map((item,index) => {
                        return (
                         
                                <div className='sub_itemContain  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                                <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
                                <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                                <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                                <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                                <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                                </div>
                            
                            
                        )
                    })
                } */}

                {/* {
                  ma.map((item,index) => {
                    console.log('ma...', item)
                        return (
                            <div className='sub_itemContain  bg-white border-top py-3 px-3 d-flex align-items-center justify-content-between'>
                                        <div className='sub_name_trim'> {item.fieldvalue.substring(0, 2)}</div>
         
                                        <div className='sub__item'><h4>{item.fieldvalue}</h4><span>Max Marks {item.max_marks}</span></div>
                                        <div className='sub__item'><h4> {item.obtain_marks} Marks</h4><span>Highest  {item.highestmarks}%</span></div>
                                        <div className='sub__item'><h4>{item.percentage}%</h4><span>Average {item.avgmarks}%</span></div>
                                        <div className='sub__item'><h4>{item.percentile == null ? 'NaN':item.percentile}</h4><span>Percentile</span></div>
                                        </div>
                        )
                    })
                } */}
                
            </div>
        </div>
        </>
    )
}

export default SubjectScore